import _definePage_default_0 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/[...path].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/categories.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/create-post.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/edit-posts.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/edit-posts.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/entities.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/geoscopes.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/manage-tags.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/manage-users.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/profile.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/auth/login.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/index.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/:path(.*)',
    name: 'CatchAllPage',
    component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/[...path].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/admin-panel',
    name: 'AdminPanel',
    component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'categories',
        name: 'ManageCategories',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/categories.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'create-post',
        name: 'CreatePost',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/create-post.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'edit-posts',
        name: 'EditPosts',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/edit-posts.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'edit-posts/:id',
        name: 'EditPost',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/edit-posts.[id].vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: 'entities',
        name: 'ManageEntities',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/entities.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: 'geoscopes',
        name: 'ManageGeoscopes',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/geoscopes.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'manage-tags',
        name: 'ManageTags',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/manage-tags.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'manage-users',
        name: 'ManageUsers',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/manage-users.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'profile/:id',
        name: 'ProfilePage',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/admin-panel/profile.[id].vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  _definePage_default_11
  ),
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/auth.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'LoginPage',
        component: () => import('/home/user/Desktop/ImposterBot/imposter-admin-panel/src/pages/auth/login.vue'),
        /* no children */
      },
  _definePage_default_12
  )
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

